import { FormInput } from "components/Extra/FormInput"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Row,
} from "reactstrap"
import React from "react"
import { CurrentStage } from "pages/vendor/Offers/Modals/AddNewOffer/AddNewOffer"
import { useTranslation } from "react-i18next"

interface DateSectionProps {
  openSecondAccordion: string
  setOpenSecondAccordion: React.Dispatch<React.SetStateAction<string>>
  validation: any
  currentStage: CurrentStage
}

export const DateSection: React.FC<DateSectionProps> = ({
  openSecondAccordion,
  setOpenSecondAccordion,
  validation,
  currentStage,
}) => {
  const { t } = useTranslation()

  return (
    <Accordion open={openSecondAccordion} className="mt-4">
      <AccordionItem>
        <AccordionHeader
          targetId="0"
          onClick={() =>
            setOpenSecondAccordion(openSecondAccordion === "0" ? "1" : "0")
          }
        >
          {t("campaigns_schedule")}
        </AccordionHeader>
        <AccordionBody accordionId="0">
          <Row>
            <Col md="6">
              <FormInput
                label={t("common_startDate") as string}
                name="startDate"
                type="date"
                validation={validation}
                required
                readOnly={currentStage === "preview"}
              />
            </Col>
            <Col md="6">
              <FormInput
                label={t("common_endDate") as string}
                name="endDate"
                type="date"
                validation={validation}
                required
                readOnly={currentStage === "preview"}
              />
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <FormInput
                label={t("common_periodTimeFrom") as string}
                name="timeFrom"
                type="time"
                validation={validation}
                required
                readOnly={currentStage === "preview"}
              />
            </Col>
            <Col md="6">
              <FormInput
                label={t("common_periodTimeTo") as string}
                name="timeTo"
                type="time"
                validation={validation}
                required
                readOnly={currentStage === "preview"}
              />
            </Col>
          </Row>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  )
}
